<template>
  <div>
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :rules="baseRules"
            :isDisabledForm="disableBaseFormData"
            :isQueryPanel="false"
            @changeMethod="changeMethod"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <!-- :isShowDownBtn="uploadDisabled" -->
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="cpllapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="this.pageMode == 1"
            :fileType="fileType"
            :fileSize="fileSize"
            :limitFileCount="10"
          />
        </div>
      </el-collapse-item>
      <div class="text-center" v-if="this.pageMode != 1">
        <el-button type="primary" @click="saveClick">保存</el-button>
        <el-button @click="cancelClick">取消</el-button>
      </div>
    </el-collapse>
  </div>
</template>

<script>
  import { tableColumns } from './columns/tableColumns.js';
  import { baseRules } from './columns/tableRules.js';
  import AnnouncementServiceMixin from '@/pages/property/announcement/mixins/announcementServiceMixin';
  export default {
    name: 'announcementCreate',
    mixins: [AnnouncementServiceMixin],
    data() {
      return {
        activeCollapses: ['1', '2'],
        // attachments: [],
        baseRules,
        baseInfoData: {
          title: '',
          type: '',
          subtitle: '',
          content: '',
          issuerPersonName: '',
          issuerPersonNo: '',
          issuerDate: '',
          createPersonName: null,
          gmtCreateShow: '',
          id: null,
        },
        id: null,
        pageMode: 0,
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        fileSize: 10,
      };
    },
    computed: {
      baseColumns() {
        return tableColumns(this);
      },
      disableBaseFormData() {
        return this.pageMode == 1;
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
        this.id = this.$route.query?.id;
      }
      this.init();
      console.log(this.userInfo, 'userInfo');
    },
    methods: {
      changeMethod({ val, prop }) {
        console.log(val, prop);
        if (prop == 'issuerPersonNo') {
          this.baseInfoData.issuerPersonName = val[0].personName;
          this.baseInfoData.issuerPersonNo = val[0].personNo;
        }
      },
      async init() {
        await this.initDetail();
      },
      //保存
      saveClick() {
        this.save(this.baseInfoData, this.id);
      },
      //取消
      cancelClick() {
        this.$confirm('确认取消吗?', '提示')
          .then(() => {
            // this.$router.push(path);
            this.closeCurrentAndToList();
          })
          .catch(() => {
            console.log('取消');
          });
      },
    },
    components: {},
  };
</script>

<style></style>
